import React,{useState} from 'react'
import { Tooltip } from 'antd';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { TooltipPlacement } from 'antd/lib/tooltip';


interface Options{
    title:string,
    action:(e:React.MouseEvent)=>void,
    data?: []
}
interface PopUpTypes {
    opts:Array<Options>
    trigger?:string,
    color?:string,
    placement?:TooltipPlacement,
    title?:React.ReactNode,
    data?: [] | any
}

const PopUp = ({opts,trigger,color,placement, data}:PopUpTypes)=>{

    type optionsType = {
        data?: [] | any;
        title:string,
        action:(e:React.MouseEvent) => void
    }

    const [visible,setVisible] = useState<boolean>(false)

    const closeTooltip = (e:React.MouseEvent, opt:optionsType) =>{
        if (opt.data) {
            window.sessionStorage.setItem('popUpData', JSON.stringify(opt.data))
        }
        setVisible(false)
        opt.action(e)
    }

    const  handleVisibleChange = (visible:boolean) => {
        setVisible(visible)
      };

    return (
        <Tooltip 
            overlayInnerStyle={{padding:'0'}}
            overlayClassName='action-popup' 
            placement={placement}
            color={color} 
            trigger={trigger} 
            visible={visible}
            onVisibleChange={handleVisibleChange}
            title={
            <div className='action-popup-title'>
                {!!opts.length &&
                    opts.map((opt,index)=>{
                        return(
                            <div key={index} onClick={(e)=>{closeTooltip(e, opt)}}>
                                <p>{opt.title}</p>
                            </div>
                        )
                    })
                }
            </div>
        }>
            <button onClick={(e)=> e.stopPropagation()} className='action-btn' >
                <MoreVertIcon style={{ color: '#1F86A7' }}/>
            </button>
        </Tooltip>
    )
}

export default PopUp
export type { PopUpTypes }
